module.exports = __webpack_public_path__ + "static/media/roomc1.17464cb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/roomc1.jpg
// module id = 889
// module chunks = 0